export const OPEN_24_HOURS = '24 hours';
export const OPEN_24_HOURS_TEXT = 'Mở cả ngày';
export const OPEN = 'Mở cửa';
export const CLOSED = 'Đóng cửa';
export const FORMAT_TIME = 'HH:mm';
export const TIME_24_HOUR = {
  isOpen: true,
  open24Hrs: true,
  times: [{open: '01:00',close: '23:59'}]
}

export const TIME_CLOSED = {
  isOpen: false,
  open24Hrs: false,
  times: [{open: '00:00',close: '00:00'}]
}

export const TIME_UPDATE = (open, close) =>  {    
    return {
        isOpen: true,
        open24Hrs: false,
        times: [{open: open, close: close }]
    }
}

export const regularHours = [
    {
      name: 'Monday',
      label: 'Thứ 2',
      symbol: 'T2',
      id: 2,
      ...TIME_CLOSED
    },
    {
      name: 'Tuesday',
      label: 'Thứ 3',
      symbol: 'T3',
      id: 3,
      ...TIME_CLOSED
    },
    {
      name: 'Wednesday',
      label: 'Thứ 4',
      symbol: 'T4',
      id: 4,
      isOpen: true,
      open24Hrs: false,
      ...TIME_CLOSED
    },
    {
      name: 'Thursday',
      label: 'Thứ 5',
      symbol: 'T5',
      id: 5,
      ...TIME_CLOSED
    },
    {
      name: 'Friday',
      label: 'Thứ 6',
      symbol: 'T6',
      id: 6,
      ...TIME_CLOSED
    },
    {
      name: 'Saturday',
      label: 'Thứ 7',
      symbol: 'T7',
      id: 7,
      ...TIME_CLOSED
    },
    {
        name: 'Sunday',
        label: 'Chủ nhật',
        symbol: 'CN',
        id: 1,
        ...TIME_CLOSED
      },    
  ];